import React, {useRef, useState} from 'react';
import {openPropertyClaimsModal} from '../../actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import propertyWriter from '../../lib/urlWriters/webURL';
import styles from './Members.scss';
import _isEmpty from 'lodash/isEmpty';
import Loading from '../Loading/Loading';
import Close from '@material-ui/icons/Close';
import {isOnMobileDevice} from '../../lib/share';
import {propertyFormat} from '../../lib/propertyFormat';

const ClaimedPropertyItem = ({claim, onClickUnclaim, key}) => {
  const {property} = claim;
  const formattedProperty = propertyFormat(property);
  const propertyRef = useRef(null);
  const image = property.links.filter((p) => p.rel === 'mainImage')[0];
  const link = property.links.filter((p) => p.rel === 'othWebUrl')[0];
  const [showShareDropdown, setShowShareDropdown] = useState(false);

  const handleShowShareDropdownChange = () => {
    if (navigator.share && isOnMobileDevice(navigator)) {
      navigator.share({
        title: formattedProperty.address.formattedAddress,
        text: 'Check out this property I found on OnTheHouse: ',
        url: window.location.href,
      }).then(() => {
      });
    } else {
      setShowShareDropdown(!showShareDropdown);
    }
  };

  return (
    <div className={'d-flex justify-content-between align-items-center pt-4'} key={key}>
      <div className={styles.propertyAddress}>
        <img
          src={`${image?.href ? image.href
            : '/assets/images/icon_happy.svg'}`}/>
        <a href={propertyWriter(property)}>
          {formattedProperty.address.formattedAddress}
        </a>
      </div>

      <div className={'d-flex align-items-center'}>
        <div className={styles.unclaimButton} onClick={onClickUnclaim}>
          <label className={styles.buttonLabel}>Unclaim Home</label>
          <Close/>
        </div>
      </div>
    </div>);
};

const DefaultContent = (props) =>
  <div className={styles.emptyContent}>
    <img src={'/assets/images/claimedHome.png'} alt={'Claimed Properties'}/>
    <div>
      <h3>Claim your Home</h3>
      <p>Find and claim your home to enjoy exclusive features only available to owners.</p>
      <button className={'pl-3 pr-3 mt-3 odinButton inline'} onClick={() => props.history.push('/')}>
        Search for your Home
      </button>

    </div>
  </div>;

const ClaimedProperties = (props) => {
  const {propertyClaims, openPropertyClaimsModal, history} = props;

  const claimedList = propertyClaims.claim_list.filter((c) =>
    c.status === 'VERIFIED' || c.status === 'NOT_VERIFIED');

  return (propertyClaims.status === 'fetching' ? <Loading/> :
    <div className={'mt-5 mb-5 ' + styles.members}>
      <h3 className="mb-4">My Properties</h3>
      <p>By claiming your home you have access to exclusive features only available to owners.</p>
      <div className={'mt-4 ' + styles.content}>

        {!_isEmpty(claimedList) ?
          <div className={'pb-4'}>
            {claimedList.map((item, index) =>
              <ClaimedPropertyItem
                key={item.propertyClaimId + index}
                claim={item}
                onClickUnclaim={() => {
                  openPropertyClaimsModal(item);
                }}
              />
            )}
          </div>
          :
          <DefaultContent history={history}/>
        }
      </div>
    </div>);
};

const mapStateToProps = (state) => {
  return {
    propertyClaims: state.propertyClaims
  };
};

const mapDispatchToProps = {
  openPropertyClaimsModal
};

ClaimedProperties.propTypes = {
  propertyClaims: PropTypes.object,
  openPropertyClaimsModal: PropTypes.func,
  history: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClaimedProperties);
